import { css } from 'styled-components';

import theme from 'styles/token/color';

/**
 * @desc 색상을 변환하는 함수
 * @param {string} color - 컬러 변수
 * @returns {String} hex 컬러 값
 */
export const getColorStyle = (color) => {
  const styleBadgeColor = {
    active: 'primary',
    // active: "green500",
    paused: 'yellow100',
    stopped: 'red700',
    connected: 'gray600',
    // enterprise 신청 상태 아이콘
    REQUEST: 'green500',
    CANCELLATION: 'yellow100',
    PREPARING: 'purple500',
    ACCEPTANCE: 'primary',
    REJECTION: 'red700',
  };

  const resolvedColor = styleBadgeColor[color] || color;
  const colorValue = theme.color[resolvedColor] || theme.color.gray400;

  return css`
    color: ${colorValue};
  `;
};
